/** @jsx jsx */

import { Grid, Select, SelectItem, Surface, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    padding: 15px;
  `,
};

type Props = {
  onChangePeriod: (value) => void;
  periodToShow: string;
};

const dropdownItems = [
  { label: 'last hour', value: '1h' },
  { label: 'last 12 hours', value: '12h' },
  { label: 'last day', value: '1d' },
  { label: 'last week', value: '1w' },
];

function Period({ onChangePeriod, periodToShow }: Props) {
  return (
    <Surface borderColor="GrayWarm4">
      <div css={Styles.root} data-testid="Period">
        <Grid columns={1} gap={10}>
          <Text tag="h3" type="Body4">
            Period
          </Text>
          <Text tag="p">
            Choose the period of time to view events in the chart.
          </Text>
          <Select
            isLabelHidden={true}
            label="Period"
            onChange={key => {
              const item = dropdownItems.find(({ value }) => value === key);
              if (item) {
                onChangePeriod(item);
              }
            }}
            selectedKey={periodToShow}
            size="medium"
          >
            {dropdownItems.map(item => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </Select>
        </Grid>
      </div>
    </Surface>
  );
}

export default Period;
